import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfirmMarkSignedModal = ({
  isOpen,
  loading,
  onConfirm,
  onReject
}) => {
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "mark-signed-modal",
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.markSigned.modal.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.markSigned.modal.text"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.markSigned.modal.confirm"
    }),
    onConfirm: onConfirm,
    ConfirmButton: UILoadingButton,
    confirmButtonProps: {
      loading,
      'data-test-id': 'mark-signed-confirm'
    },
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.markSigned.modal.cancel"
    }),
    onReject: onReject,
    size: "auto"
  });
};
export default ConfirmMarkSignedModal;